// DS8.1.3
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ModalRoot } from '../../base';
import ModalDoNotShowAgain from './ModalDoNotShowAgain';
import HorizontalLayout from './layouts/HorizontalLayout';
import VerticalLayout from './layouts/VerticalLayout';
const MessageModal = (_param)=>{
    var { variant, title, message, image, footerButtons, doNotShowAgainText, onDoNotShowAgainChange, contentClassName } = _param, rest = _object_without_properties(_param, [
        "variant",
        "title",
        "message",
        "image",
        "footerButtons",
        "doNotShowAgainText",
        "onDoNotShowAgainChange",
        "contentClassName"
    ]);
    const isMobile = useContext(MobileContext);
    const isFullscreen = isMobile || false;
    return /*#__PURE__*/ React.createElement(ModalRoot, _object_spread({
        isFullscreen: isFullscreen
    }, rest), variant === 'horizontal' ? /*#__PURE__*/ React.createElement(HorizontalLayout, {
        image: image,
        title: title,
        message: message,
        contentClassName: contentClassName,
        footerLeft: [
            onDoNotShowAgainChange && /*#__PURE__*/ React.createElement(ModalDoNotShowAgain, {
                key: "dns",
                doNotShowAgainText: doNotShowAgainText || '',
                onDoNotShowAgainChange: onDoNotShowAgainChange
            })
        ],
        footerRight: footerButtons,
        isFullscreen: isFullscreen
    }) : /*#__PURE__*/ React.createElement(VerticalLayout, {
        image: image,
        title: title,
        message: message,
        contentClassName: contentClassName,
        footerButtons: footerButtons,
        footerExtras: onDoNotShowAgainChange && /*#__PURE__*/ React.createElement(ModalDoNotShowAgain, {
            key: "dns",
            doNotShowAgainText: doNotShowAgainText || '',
            onDoNotShowAgainChange: onDoNotShowAgainChange
        }),
        isFullscreen: isFullscreen
    }));
};
MessageModal.displayName = 'MessageModal';
export default MessageModal;

//# sourceMappingURL=MessageModal.js.map